import React from 'react';
import PropTypes from 'prop-types';
import ErrorIcon from '../../assets/images/icon_error_messages.gif';
import EN from '../../EN.json';
import FR from '../../FR.json';

const ErrorMessages = ({ error }) => {
  const {
    USERS: {
      USER_AUTHENTICATION: {
        labels,
        ERRORS_MESSAGES:{
          GENERIC_ERROR_HEADING
        }
      },
    }
  } =  localStorage.getItem('locale') ? (localStorage.getItem('locale') === 'EN' ? EN : FR) : EN;
  return (
    <>
      <h2>
        <div id="main-content-title">
          <span
            className="frg-icon icon-user-profile-inverted"
            style={{ paddingRight: 10, fontSize: 26 }}
          />
          {labels.UPDATE_PASSWORD_TITLE}
        </div>
      </h2>
      {error ? (
        <div id="error-message-content" style={{ display: 'block' }}>
          <div id="error-message-icon">
            <img src={ErrorIcon} alt="error_icon" />
          </div>
          <div id="error-message-title">
            <span className="frg-body-font-23px">{GENERIC_ERROR_HEADING}</span>
          </div>
          <div className="clear" />
          <div id="error-message-message">
            <span className="frg-body-font-14px">
              {error}
              <br />
            </span>
          </div>
        </div>
      ) : null}
    </>
  );
};

ErrorMessages.propTypes = {
  error: PropTypes.bool.isRequired
};
export default ErrorMessages;
